import Widget from "../../components/Widget/Widget.js";
import BatteryStatusWidget from "./components/ClientDashboardComponents/BatteryStatusWidget.js";
import BatteryPerformanceWidget from "./components/ClientDashboardComponents/BatteryPerformanceWidget.js";
import ErrorsTimeline from "./components/ClientDashboardComponents/ErrorsTimeline.js";
import PowerConsumptionChart from "./components/MonitoringComponents/PowerConsumptionChart.js";
import styles from "./Monitoring.module.scss";
import { useSelector } from "react-redux";

export default function ClientDashboard() {
  const store = useSelector((state) => state.auth);

  if (!store?.currentUser?.clientRole?.role) {
    return null;
  }

  const clientRole = store.currentUser.clientRole.role;
  const building = store.currentUser.clientRole.building;
  const hasBattery = building?.battery_table !== null;

  return (
    <div>
      <div className={styles.WidgetContainer}>
        <Widget title="Power Consumption">
          <PowerConsumptionChart 
            buildingId={building.id} 
            userRole={clientRole}  
          />
        </Widget>
      </div>
      {hasBattery && (
        <div>
          <div className = {styles.WidgetWrapper}>
            <div className={styles.WidgetHalfContainer}>
              <Widget title="Battery Status">
                <BatteryStatusWidget building={building}/>
              </Widget>
            </div>

            <div className={styles.WidgetHalfContainer}>
              <Widget title="Battery Errors">
                <ErrorsTimeline building={building}/>
              </Widget>
            </div>
          </div>

          <div className={styles.WidgetContainer}>
            <Widget title="Battery Performance">
              <BatteryPerformanceWidget building={building}/>
            </Widget>
          </div>
        </div>
      )}
    </div>
  );
}
